export const GET_WORKING_HOUR = "GET_WORKING_HOUR";

export const LIST_BUSINESS_BLOCK_TIME = "LIST_BUSINESS_BLOCK_TIME";

export const LIST_STAFF_BLOCK_TIME = "LIST_STAFF_BLOCK_TIME";

export const GET_BUSINESS_TIME_OFF = "GET_BUSINESS_TIME_OFF";

export const CREATE_BUSINESS_TIME_OFF = "CREATE_BUSINESS_TIME_OFF";

export const UPDATE_BUSINESS_TIME_OFF = "UPDATE_BUSINESS_TIME_OFF";

export const DELETE_BUSINESS_TIME_OFF = "DELETE_BUSINESS_TIME_OFF";


